
    import '/opt/buildhome/repo/packages/x/docs/playground/ultramodern.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-ultramodern-demo-ultramodern"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/playground/ultramodern.en-US.md?type=demo')
};